import { AxiosInstance, AxiosResponse } from 'axios'
import { Permission } from '../types/index.js'

export default class PermissionsAPI {
  public _client: AxiosInstance

  constructor(axios: AxiosInstance) {
    this._client = axios
  }

  public async list(organizationId?: number): Promise<Array<Permission>> {
    const result: AxiosResponse = await this._client.get(`permissions`, {
      params: { filter: { organizationId } },
    })

    return result.data?.data.map((enm: any) => enm.attributes) ?? []
  }
}
